import { create } from 'zustand'

export type IncompleteUserDetails = {
  firstName: string
  lastName: string
  email: string
  countryCode: string
  phone: string
}

type IncompleteUserState = IncompleteUserDetails & {
  modalVisible: boolean
  setModalVisible: (visible: boolean) => void
  setUserDetails: (details: Partial<IncompleteUserDetails>) => void
  getUserDetails: () => IncompleteUserDetails
}

const useIncompleteUserStore = create<IncompleteUserState>((set, get) => ({
  modalVisible: false,
  firstName: '',
  lastName: '',
  email: '',
  countryCode: '',
  phone: '',
  setModalVisible: (visible) => set({ modalVisible: visible }),
  setUserDetails: (details) =>
    set((state) => ({
      ...state,
      ...details,
    })),
  getUserDetails: () => {
    const { firstName, lastName, email, countryCode, phone } = get()

    return { firstName, lastName, email, countryCode, phone }
  },
}))

export default useIncompleteUserStore
